// removed by extract-text-webpack-plugin
module.exports = {"image":"style__image___2EpQQ","container":"style__container___175Ef","video":"style__video___gG__P","img":"style__img___2NSh-","imgBg":"style__imgBg___3vHtf"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/components/media-video/style.css
// module id = 1263
// module chunks = 0